document.addEventListener('DOMContentLoaded', function () {
  function wireCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    if (window.pandaEnableDragScroll) window.pandaEnableDragScroll(track);
    var step = function () {
      var card = track.querySelector('[data-carousel-card]');
      return card ? card.getBoundingClientRect().width + 16 : 296;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  document.querySelectorAll('[data-carousel]').forEach(wireCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-carousel]').forEach(wireCarousel);
  });
});
